export default function InlineIllustration(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={277}
      height={200}
      fill="none"
      viewBox="0 0 800 578"
      {...props}
    >
      <rect
        width={133.333}
        height={97.778}
        x={55.553}
        y={62.219}
        fill="#52E3AC"
        rx={13.333}
      />
      <rect
        width={133.333}
        height={97.778}
        x={55.553}
        y={284.438}
        fill="#52E3AC"
        rx={13.333}
      />
      <rect
        width={44.444}
        height={44.444}
        x={459.996}
        y={88.879}
        fill="#52E3AC"
        rx={8.889}
      />
      <rect
        width={44.444}
        height={44.444}
        x={364.439}
        y={311.109}
        fill="#52E3AC"
        rx={8.889}
      />
      <path
        stroke="#D6D6D6"
        strokeWidth={17.778}
        d="M244.447 66.656h311.111M244.447 111.102h193.334M244.447 511.105h193.334M244.447 155.547h311.111M244.447 199.996h257.778M244.447 244.438h311.111M244.447 288.887h311.111M244.447 333.32h97.778M429.998 333.32h97.778M244.447 377.777h311.111M244.447 422.215h257.778M244.447 466.656h311.111"
      />
    </svg>
  );
}
